module.exports = __webpack_public_path__ + "static/media/wave.77596227.svg";